import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import Box from "@mui/material/Box";
import {TreeView} from "@mui/x-tree-view/TreeView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React from "react";
import StyledTreeItem from "./TreeItem";


function RichObjectTreeView( folders, goToFolder, allFoldersParentsMap, panelWidth, allFolders ) {
    const renderTreeItems = (folderId, parentsFolders=[]) => {
        const childFolders = allFoldersParentsMap.get(folderId);
        if (!childFolders) {
            return null;
        }
        const updatedParentsFolders = [...parentsFolders, folderId];

        parentsFolders=[...parentsFolders, { folderId: folderId, folderName: allFolders.filter(fold=>fold._id===folderId)[0].FolderName }];
        return childFolders.map((childFolder) => {
            return (
                <StyledTreeItem
                    key={childFolder._id}
                    nodeId={childFolder._id}
                    labelText={childFolder.FolderName}
                    labelIcon={FolderOutlinedIcon}
                    onClickFolder={() => goToFolder({ folderId: childFolder._id, folderName: childFolder.FolderName }, parentsFolders)}
                    style={{ paddingLeft: `${updatedParentsFolders.length + 10}px` }}
                >
                    {renderTreeItems(childFolder._id, parentsFolders)}
                </StyledTreeItem>
            );
        });
    };

    return (
        <Box sx={{ width: panelWidth }}>
            <TreeView
                aria-label="rich object"
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                defaultEndIcon={<div style={{ width: 24 }} />}
                sx={{ flexGrow: 1, overflowY: 'auto' }}
            >
                {folders.map((folder) => (
                    <StyledTreeItem
                        key={folder._id}
                        nodeId={folder._id}
                        labelText={folder.FolderName}
                        labelIcon={FolderOutlinedIcon}
                        onClickFolder={() => goToFolder({ folderId: folder._id, folderName: folder.FolderName })}
                    >
                        {renderTreeItems(folder._id)}
                    </StyledTreeItem>
                ))}
            </TreeView>
        </Box>
    );
}

export default RichObjectTreeView;